<template>
  <div>
    <div class="pupils-modal full">
      <div class="shadow-wrapper" @click="close"></div>
      <div class="pupils-modal-scroll">
        <div class="pupils-modal-wrapper">
          <Timtables :group_id="$route.params.id" :discipline_id="id" @close="close" />
        </div>
      </div>
    </div>
  </div>
  <!-- <card-item card="item_notification" :tabs="tabs" :activeTab="activeTab"  @setTab="setTab"  :id="145">
  </card-item> -->
</template>
<script>
export default {
  props: ["id"],
  data() {
    return {
      card: "item_pupils"
    };
  },
  components: {
    "Timtables": () => import("@/components/Pupils/Journal/Timetables"),
  },
  mounted(){
    // setTimeout(() => {
    //   document.querySelector(".pupils-modal").classList.add("active")
    // }, 4);
  },
   methods: {
    close(event) {
      console.log('clouuuuse')
      let query = Object.assign({}, this.$route.query);
      if (query[this.card]) {
        delete query[this.card];
      } else {
        return false;
      }
      this.$router.replace({query});
    },
  },
};
</script>
